import { Button, Form, Space, message } from "antd";
import dayjs from "dayjs";
import "moment/locale/vi"; // Import locale tiếng Việt
import React, { useEffect, useState, useCallback } from "react";
import $axios from "../../services/axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { DEFAULT_PLACE } from "../../helpers/const";
import {
  getPlaceDetailFromLatLng,
  getPlaceDetailFromPlaceId,
} from "../../helpers/utils";
import axios from "axios";
import _ from "lodash";

const GoongAutocomplete = ({
  value,
  onChange,
  onPlaceSelected,
  disabled,
  placeholder,
  iconComponent,
  showSuggestions,
  onToggleSuggestions,
  dataPlace,
}) => {
  const [suggestions, setSuggestions] = useState([]);
  const fetchSuggestions = async (inputValue, dataPlace) => {
    if (inputValue && inputValue.length > 4) {
      try {
        const params = {
          input: inputValue,
          api_key: process.env.REACT_APP_GOOGNG_API_KEY,
          radius: 20,
        };
        if (dataPlace?.from?.lat && dataPlace?.from?.lng) {
          params.location = dataPlace?.from?.lat + "," + dataPlace?.from?.lng;
        }
        const response = await axios.get(
          `https://rsapi.goong.io/Place/AutoComplete`,
          {
            params: params,
          }
        );
        setSuggestions(response.data.predictions || []);
      } catch (error) {
        console.error("Error fetching Goong places:", error);
      }
    } else {
      setSuggestions([]);
    }
  };
  const debouncedFetchSuggestions = useCallback(
    _.throttle(fetchSuggestions, 1000),
    []
  );

  const handleInputChange = async (e) => {
    const inputValue = e.target.value;
    onChange(inputValue);
    if (inputValue.length > 0 && onToggleSuggestions) {
      onToggleSuggestions(true); // Mở dropdown khi có input
    }
    debouncedFetchSuggestions(inputValue, dataPlace);
  };

  const handleSelectPlace = async (place) => {
    setSuggestions([]);
    if (onToggleSuggestions) onToggleSuggestions(false); // Đóng dropdown khi chọn
    try {
      const placeDetail = await getPlaceDetailFromPlaceId(place.place_id);
      onPlaceSelected(placeDetail);
    } catch (error) {
      onPlaceSelected(null);
      console.error("Error fetching place details:", error);
    }
  };

  const handleClearSelection = () => {
    onChange("");
    onPlaceSelected(null);
    setSuggestions([]);
  };

  return (
    <div className="autocomplete-container">
      <span className="z-10">{iconComponent}</span>
      <input
        type="text"
        value={value}
        onChange={handleInputChange}
        className={`autocomplete-input focus:border-primary hover:border-primary`}
        disabled={disabled}
        placeholder={placeholder}
        allowClear
      />
      {value && (
        <button
          onClick={handleClearSelection}
          className="absolute top-[50%] right-[8px] border-0 outline-0 w-5 h-10 bg-transparent"
          style={{ transform: "translateY(-50%)" }}
        >
          <FontAwesomeIcon icon={faClose} color="black" />
        </button>
      )}

      {showSuggestions && suggestions.length > 0 && (
        <ul className="autocomplete-suggestions">
          {suggestions.map((place) => (
            <li key={place.place_id} onClick={() => handleSelectPlace(place)}>
              {place.description}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const Booking = ({
  setLoading,
  loading,
  setDataServices,
  setStep,
  setDataPlace,
  dataPlace,
  dataInputPlace,
  setDataInputPlace,
  isPlaceHistory,
  setIsPlaceHistory,
}) => {
  const [showSuggestions, setShowSuggestions] = useState({
    from: false,
    to1: false,
    to2: false,
    to3: false,
  });
  const handleCloseSuggestions = (type) => {
    setShowSuggestions((prev) => ({
      ...prev,
      [type]: false,
    }));
  };
  const [form] = Form.useForm();
  useEffect(() => {
    if (!isPlaceHistory) {
      // Lấy vị trí hiện tại
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const { latitude, longitude } = position.coords;
            const placeDetail = await getPlaceDetailFromLatLng(
              latitude,
              longitude
            );
            if (placeDetail) {
              onChoosePlace(placeDetail, "from");
            }
          },
          (err) => {
            console.error("Lỗi khi lấy vị trí: ", err.message);
          }
        );
      } else {
        alert("Trình duyệt không hỗ trợ định vị.");
      }
    }
  }, []);

  const handleAddDestination = () => {
    const newTo = [...dataPlace.to];
    const nextIndex = newTo.findIndex((item) => !item.show);
    setDataPlace((prevState) => {
      if (nextIndex !== -1) {
        newTo[nextIndex].show = true;
      }
      return {
        ...prevState,
        to: newTo,
      };
    });
    setDataInputPlace((prevState) => ({
      ...prevState,
      [`to${nextIndex}`]: "",
    }));
  };

  const handleRemoveDestination = (index) => {
    const newTo = [...dataPlace.to];
    newTo[index] = {
      placeId: "",
      description: "",
      placeName: "",
      lat: "",
      lng: "",
      regionName: "",
      index: index,
      show: false,
    };
    setDataInputPlace((prevState) => ({
      ...prevState,
      [`to${index}`]: "",
    }));
    setDataPlace((prevState) => {
      return {
        ...prevState,
        to: newTo,
      };
    });
  };

  const onChoosePlace = (item, type = "from", index = 0) => {
    if (type === "from") {
      setDataInputPlace((prevState) => ({
        ...prevState,
        [type]: item ? item.description : "",
      }));
      setDataPlace({
        ...dataPlace,
        [type]: item
          ? {
              place_id: item.place_id,
              description: item.description,
              placeName: item.placeName,
              lat: item.lat,
              lng: item.lng,
              regionName: item.regionName,
            }
          : {
              placeId: "",
              description: "",
              placeName: "",
              lat: "",
              lng: "",
              regionName: "",
            },
      });
      handleCloseSuggestions(type);
    } else {
      // Xử lý cho điểm đến
      setDataInputPlace((prevState) => ({
        ...prevState,
        [`to${index}`]: item ? item.description : "",
      }));

      setDataPlace((prevState) => {
        const newTo = [...prevState.to];
        newTo[index] = item
          ? {
              ...newTo[index],
              placeId: item.place_id,
              description: item.description,
              placeName: item.placeName,
              lat: item.lat,
              lng: item.lng,
              regionName: item.regionName,
            }
          : {
              placeId: "",
              description: "",
              placeName: "",
              lat: "",
              lng: "",
              regionName: "",
              index: index,
              show: true,
            };
        return {
          ...prevState,
          to: newTo,
        };
      });
      handleCloseSuggestions(`${type}${index}`);
    }
  };

  const handleFinish = async (values) => {
    if (!dataInputPlace.from) {
      message.error("Vui lòng nhập điểm đón");
      return;
    }

    // Validate ít nhất 1 điểm đến
    const hasAtLeastOneDestination = dataPlace.to.some(
      (item, index) => item.show && dataInputPlace[`to${item.index}`]
    );

    if (!hasAtLeastOneDestination) {
      message.error("Vui lòng nhập ít nhất một điểm đến");
      return;
    }

    const isValidFrom =
      !!dataPlace.from &&
      !!dataPlace.from.place_id &&
      !!dataPlace.from.description &&
      !!dataPlace.from.placeName &&
      !!dataPlace.from.lat &&
      !!dataPlace.from.lng &&
      !!dataPlace.from.regionName;

    if (!isValidFrom) {
      message.error("Điểm đón không hợp lệ! Vui lòng chọn từ danh sách gợi ý");
      return;
    }

    const destinations = dataPlace.to
      .filter((item) => item.show && item.placeId)
      .map((item) => ({
        placeId: item.placeId,
        description: item.description,
        placeName: item.placeName,
        lat: item.lat,
        lng: item.lng,
        regionName: item.regionName,
      }));

    if (destinations.length === 0) {
      message.error("Điểm đến không hợp lệ! Vui lòng chọn từ danh sách gợi ý");
      return;
    }
    setLoading(true);
    try {
      const body = {
        Destinations: destinations.map((item) => `${item.lat},${item.lng}`),
        FromLocation: dataPlace.from.description,
        Origins: `${dataPlace.from.lat},${dataPlace.from.lng}`,
        ToLocations: destinations.map((item) => item.description),
        Vehicle: "CAR",
      };
      const res = await $axios.$post(`/api/v1/say-car/preview-booking`, body);
      setDataServices(res.data.data);
      setStep("map");
    } catch (error) {
      message.error(error?.response?.data?.message || "Có lỗi xảy ra");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center mt-[0px] step1 booking relative top-[100px]">
      <Form
        form={form}
        onFinish={handleFinish}
        layout="vertical"
        initialValues={{
          departDate: dayjs(),
        }}
        onFinishFailed={(values) => {
          message.error("Vui lòng chọn điểm đi và điểm đến!");
        }}
        className="form-search w-[92%]"
      >
        <div
          style={{
            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
          }}
          className="rounded-2xl bg-accent"
        >
          <div
            style={{
              boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.25)",
            }}
            className=" bg-white p-4 py-5 rounded-2xl"
          >
            <div className="flex gap-4 items-center justify-between">
              <div className="flex flex-col flex-1">
                <Space.Compact
                  className="w-full justify-between"
                  direction="horizontal"
                  block={true}
                >
                  <div className="add-start-container">
                    <GoongAutocomplete
                      value={dataInputPlace.from}
                      onChange={(value) =>
                        setDataInputPlace({ ...dataInputPlace, from: value })
                      }
                      dataPlace={dataPlace}
                      placeholder="Điểm đón"
                      onPlaceSelected={(place) => {
                        setDataPlace({
                          ...dataPlace,
                          from: place ? place : null,
                        });
                        setDataInputPlace({
                          ...dataInputPlace,
                          from: place ? place.description : "",
                        });
                        setIsPlaceHistory(false);
                      }}
                      showSuggestions={showSuggestions.from}
                      onToggleSuggestions={(show) =>
                        setShowSuggestions((prev) => ({ ...prev, from: show }))
                      }
                      iconComponent={
                        <svg
                          className="absolute top-[30%] left-3 text-primary"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.49997 10.3847C9.0931 10.3847 10.3846 9.09322 10.3846 7.50009C10.3846 5.90696 9.0931 4.61548 7.49997 4.61548C5.90684 4.61548 4.61536 5.90696 4.61536 7.50009C4.61536 9.09322 5.90684 10.3847 7.49997 10.3847Z"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="square"
                          />
                          <circle
                            cx="7.5"
                            cy="7.5"
                            r="6.75"
                            stroke="currentColor"
                            stroke-width="1.5"
                          />
                        </svg>
                      }
                    />
                  </div>
                  <div className="block w-[20px] ml-2" />
                </Space.Compact>
                {dataPlace.to
                  .filter((item) => item.show)
                  .map((item, idx) => (
                    <Space.Compact
                      key={item.index}
                      className={`w-full mt-5 justify-between`}
                      direction="horizontal"
                      block={true}
                    >
                      <div className="add-end-container">
                        <GoongAutocomplete
                          value={dataInputPlace[`to${item.index}`] || ""}
                          onChange={(value) =>
                            setDataInputPlace({
                              ...dataInputPlace,
                              [`to${item.index}`]: value,
                            })
                          }
                          dataPlace={dataPlace}
                          placeholder={`Điểm đến`}
                          onPlaceSelected={(place) => {
                            console.log(place, "place");

                            onChoosePlace(place, "to", item.index);
                          }}
                          showSuggestions={showSuggestions[`to${item.index}`]}
                          onToggleSuggestions={(show) =>
                            setShowSuggestions((prev) => ({
                              ...prev,
                              [`to${item.index}`]: show,
                            }))
                          }
                          iconComponent={
                            <svg
                              className="absolute top-[30%] left-3 text-primary"
                              width="16"
                              height="20"
                              viewBox="0 0 16 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M14.875 7.52969C14.875 12.1875 8 19.0625 8 19.0625C8 19.0625 1.125 12.1875 1.125 7.52969C1.125 3.16031 4.67781 0.625 8 0.625C11.3222 0.625 14.875 3.16031 14.875 7.52969Z"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="square"
                              />
                              <path
                                d="M8 10C9.38071 10 10.5 8.88071 10.5 7.5C10.5 6.11929 9.38071 5 8 5C6.61929 5 5.5 6.11929 5.5 7.5C5.5 8.88071 6.61929 10 8 10Z"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="square"
                              />
                            </svg>
                          }
                        />
                      </div>

                      {idx > 0 ? (
                        <svg
                          clip-rule="evenodd"
                          fill-rule="evenodd"
                          stroke-linejoin="round"
                          stroke-miterlimit="2"
                          viewBox="0 0 24 24"
                          className="text-primary w-[20px] ml-2"
                          xmlns="http://www.w3.org/2000/svg"
                          onClick={() => handleRemoveDestination(item.index)}
                        >
                          <path
                            fill="currentColor"
                            d="m12.002 2.005c5.518 0 9.998 4.48 9.998 9.997 0 5.518-4.48 9.998-9.998 9.998-5.517 0-9.997-4.48-9.997-9.998 0-5.517 4.48-9.997 9.997-9.997zm0 1.5c-4.69 0-8.497 3.807-8.497 8.497s3.807 8.498 8.497 8.498 8.498-3.808 8.498-8.498-3.808-8.497-8.498-8.497zm4.253 7.75h-8.5c-.414 0-.75.336-.75.75s.336.75.75.75h8.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75z"
                            fill-rule="nonzero"
                          />
                        </svg>
                      ) : (
                        <div className="w-[20px] ml-2 block" />
                      )}
                    </Space.Compact>
                  ))}
                {/* Nút thêm điểm đến - chỉ hiển thị nếu chưa đạt tối đa */}
                {dataPlace.to.filter((item) => item.show).length < 3 && (
                  <div
                    className="flex items-center gap-2 mt-4 cursor-pointer"
                    onClick={handleAddDestination}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      className="text-primary w-[18px] h-[18px]"
                    >
                      <path
                        fill="currentColor"
                        d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 13h-5v5h-2v-5h-5v-2h5v-5h2v5h5v2z"
                      />
                    </svg>
                    <span className="text-primary text-[14px]">
                      Thêm điểm đến
                    </span>
                  </div>
                )}
              </div>
            </div>

            <Button
              type="primary"
              htmlType="sumit"
              loading={loading}
              style={{ height: 48 }}
              className="w-full h-[48px] mt-4"
            >
              <span className="text-[16px] font-semibold">Đặt xe</span>
            </Button>
          </div>
          <div className="py-5 px-4 rounded-ee-2xl rounded-es-2xl flex justify-between items-center">
            <span className="font-semibold"> Bạn đã có mã đơn hàng? </span>
            <Button
              onClick={() => setStep("history")}
              variant="outlined"
              className="bg-transparent rounded-lg w-[113px] h-[36px] border-[1px] border-solid border-primary text-primary"
            >
              <span className="text-[16px] font-semibold">Tra cứu ngay</span>
            </Button>
          </div>
        </div>
      </Form>
      <div className="text-center my-6">
        <span className="text-[#808080] font-normal">
          Hotline hỗ trợ khách hàng{" "}
        </span>
        <a href="tel:1900255585" className="font-bold text-primary text-[16px]">
          1900255585
        </a>
      </div>
      <div className="flex flex-col items-center w-full gap-4">
        {DEFAULT_PLACE.map((item, index) => (
          <div
            onClick={() => onChoosePlace(item, "to")}
            key={index}
            className="flex gap-2 w-full justify-center px-4"
          >
            <div className="w-[20px]">
              <svg
                width="16"
                height="21"
                viewBox="0 0 16 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="text-primary"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.79727 20.2298C7.00612 20.2298 3.23217 15.6148 2.24019 14.007C0.816937 11.7003 0 10.3422 0 7.77778C0 3.48223 3.49096 0 7.79727 0C12.1036 0 15.5945 3.48223 15.5945 7.77778C15.5945 10.3289 14.7129 11.6961 13.2849 14.007C12.3559 15.5104 8.58842 20.2298 7.79727 20.2298ZM7.79727 11.6667C9.95043 11.6667 11.6959 9.92555 11.6959 7.77778C11.6959 5.63 9.95043 3.88889 7.79727 3.88889C5.64411 3.88889 3.89864 5.63 3.89864 7.77778C3.89864 9.92555 5.64411 11.6667 7.79727 11.6667Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="ml-2 flex-1 gap-2 flex flex-col">
              <div className="text-[14px] font-medium">{item.placeName}</div>
              <div className="border-b-[1px] border-solid border-0 pb-4 border-[#D1D5DB]">
                <span className="text-[12px] font-normal">
                  {item.description}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Booking;
